import { render } from "./AlphaGoat01Tiers.vue?vue&type=template&id=0a3fe81a&scoped=true"
const script = {}

import "./AlphaGoat01Tiers.vue?vue&type=style&index=0&id=0a3fe81a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3fe81a"]])

export default __exports__